import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCirclePaymentSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#56A" opacity={0.88} />
      <rect
        width={26}
        height={20}
        x={9.8}
        y={18.71}
        fill="#8F9DD6"
        rx={2}
        transform="rotate(-15 9.8 18.7)"
      />
      <rect width={26} height={20} x={15} y={18} fill="#fff" rx={2} />
      <path
        fill="#8F9DD6"
        d="M18 33.35c0-.2.16-.35.35-.35h5.3c.2 0 .35.16.35.35v2.3c0 .2-.16.35-.35.35h-5.3a.35.35 0 01-.35-.35z"
      />
      <path fill="#6A79B4" d="M15 24h26v3H15z" />
    </svg>
  );
}

SvgPicCirclePaymentSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCirclePaymentSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCirclePaymentSelected svgRef={ref} {...props} />
));
export default ForwardRef;
